import {
  GET_EXCO_KELURAHAN,
  GET_EXCO_KELURAHAN_SUCCESS,
  GET_EXCO_KELURAHAN_FAIL,
} from "./actionTypes";
import { API } from "../../API/api";

export const getTableKelurahan= (param,page,search,sort,sortType,filterProv,filterCities,filterKecamatan) => (dispatch) => {
  dispatch({
    type: GET_EXCO_KELURAHAN,
  });

  const request = API.getTableExco(param,page,search,sort,sortType,filterProv,filterCities,filterKecamatan);
  return request.then(
    (response) => dispatch(getTableKelurahanSuccess(response.data)),
    (err) => dispatch(getTableKelurahanFail(err))
  );
};

export const getTableKelurahanSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_KELURAHAN_SUCCESS,
    payload: data,
  });
};

export const getTableKelurahanFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_KELURAHAN_FAIL,
    payload: data,
  });
};
